import { Repeat } from "lucide-react";
import { Card } from "@/components/ui/card";

const fmtBRL = (v) =>
  Number(v ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });
  } catch {
    return "—";
  }
};

export default function SubscriptionSummaryCard({ data }) {
  const items = data?.items || [];
  const count = data?.subscriptions_count ?? 0;

  return (
    <Card variant="elevated" className="p-4 max-w-md">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-9 h-9 rounded-lg bg-purple-500/10 flex items-center justify-center">
          <Repeat className="w-4 h-4 text-purple-400" />
        </div>
        <div className="flex-1">
          <div className="text-xs text-foreground-muted">
            {count} {count === 1 ? "assinatura ativa" : "assinaturas ativas"}
          </div>
          <div className="text-2xl font-bold text-foreground">
            {fmtBRL(data?.total_monthly)}
            <span className="text-xs font-normal text-foreground-muted ml-1">/ mês</span>
          </div>
        </div>
      </div>

      {data?.next_subscription && (
        <div className="mb-3 py-2 px-3 rounded-lg bg-surface-card-hover">
          <div className="text-[10px] text-foreground-muted uppercase tracking-wider">
            Próxima cobrança
          </div>
          <div className="flex items-center justify-between">
            <span className="text-sm text-foreground">{data.next_subscription}</span>
            <span className="text-xs text-foreground-muted">{fmtDate(data.next_billing)}</span>
          </div>
        </div>
      )}

      {items.length > 0 ? (
        <div className="space-y-1">
          <div className="text-[10px] text-foreground-muted uppercase tracking-wider mb-1">
            Suas assinaturas
          </div>
          {items.slice(0, 6).map((s) => (
            <div
              key={s.id || s.name}
              className="flex items-center justify-between py-1 px-3 rounded-lg bg-surface-card-hover"
            >
              <div className="min-w-0 mr-2">
                <div className="text-xs text-foreground truncate">{s.name}</div>
                {s.merchant && s.merchant !== s.name && (
                  <div className="text-[10px] text-foreground-muted truncate">
                    {s.merchant}
                  </div>
                )}
              </div>
              <div className="text-xs font-semibold text-foreground whitespace-nowrap">
                {fmtBRL(s.amount)}
                <span className="text-[9px] font-normal text-foreground-muted ml-1">
                  {s.frequency === "monthly" ? "/mês" : s.frequency === "annual" ? "/ano" : ""}
                </span>
              </div>
            </div>
          ))}
          {items.length > 6 && (
            <div className="text-[10px] text-foreground-muted text-center pt-1">
              + {items.length - 6} mais
            </div>
          )}
        </div>
      ) : (
        <div className="text-xs text-foreground-muted py-3 text-center">
          Nenhuma assinatura ativa.
        </div>
      )}
    </Card>
  );
}
